import CompanyServicesRepository from '@/repositories/CompanyServicesRepository'

export default {
  methods: {
    goToFreedomAndFlow () {
      CompanyServicesRepository.getFreedomAndFlowUrl().then((response) => {
        window.location.href = response.data
      })
    },
    goToWellwo (path = '') {
      CompanyServicesRepository.getWellwoUrl(path).then((response) => {
        window.location.href = response.data
      })
    },
    goToRehBody () {
      CompanyServicesRepository.getRehBodyUrl().then((response) => {
        window.location.href = response.data
      })
    },
    goToTmc (tmcEnabled) {
      if (tmcEnabled) {
        window.location.href = this.$helpers.getV2AppUrl('patient/sso-tmc')
      } else {
        this.$helpers.showSharedDialog(this.$t('companyServices.tmc.disabled.title'), this.$t('companyServices.tmc.disabled.message'))
      }
    },
    goToHealthyCommunity (path = '') {
      window.open(this.$helpers.getHealthyCommunityUrl(path), '_blank')
    },
		goToWhoSignsUp () {
			this.goToHealthyCommunity('quienseapunta')
		},
    goToOpensaludPrime (token) {
      this.$helpers.goToPatientWebApp('goOpensaludprime', token)
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/companyServices.mixin.js